import { useSyncExternalStore } from "react";

function subscribe(onStoreChange: () => void) {
  document.addEventListener("visibilitychange", onStoreChange);
  return () => document.removeEventListener("visibilitychange", onStoreChange);
}

function getSnapshot() {
  return document.visibilityState === "visible";
}

function getServerSnapshot() {
  return true;
}

/**
 * 문서가 포그라운드(foreground)에 있을 때만 `true`.
 * 모바일 백그라운드·다른 탭으로 전환 시 `false`.
 */
export function useIsDocumentForeground() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
